import { useEffect } from 'react';

export const useVisualViewportHeight = (): void => {
  useEffect(() => {
    if (typeof window === 'undefined') {
      return;
    }

    const viewport = window.visualViewport;
    const updateHeight = (): void => {
      const height = viewport?.height ?? window.innerHeight;
      document.documentElement.style.setProperty('--visual-viewport-height', `${height}px`);
    };

    updateHeight();

    viewport?.addEventListener('resize', updateHeight);
    window.addEventListener('resize', updateHeight);

    return (): void => {
      viewport?.removeEventListener('resize', updateHeight);
      window.removeEventListener('resize', updateHeight);
    };
  }, []);
};

